import { render } from "./VatRateList.vue?vue&type=template&id=13a20697&scoped=true"
import script from "./VatRateList.vue?vue&type=script&lang=js"
export * from "./VatRateList.vue?vue&type=script&lang=js"

import "./VatRateList.vue?vue&type=style&index=0&id=13a20697&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a20697"]])

export default __exports__